import { render, staticRenderFns } from "./SearchNewContact.vue?vue&type=template&id=924dd048&scoped=true"
import script from "./SearchNewContact.vue?vue&type=script&lang=js"
export * from "./SearchNewContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924dd048",
  null
  
)

export default component.exports